
(function(template){
    define('vue!app/views/vue/components/packageDivComponent/packageSelectionComponent/packageItem',['Vue','vue!./packageItemDetails','helpers'],function(Vue,packageItemDetails,helpers){
        return {
            template: template,
            props: ['pkg','showDetails','index'],
            components: {
                'package-item-details' : packageItemDetails
            },
            methods: {
                handleKeyDown: function(e){
                    this.a11yKeyDown(e,{
                        enter: function() {
                            e.target.click();
                        }
                    })
                },
                toggleDropdown: function(e){
                    var val = null;
                    if(this.index != this.showDetails) {
                        val = this.index;
                    }
                    this.$emit('update:showDetails', val);
                },
            }
        }
    })
})('<div role="button" aria-label="Select Package Item" @click="toggleDropdown" tabindex="0" @keydown="handleKeyDown" > <div class="packageItem header"> {{pkg.ItemName}} <span> {{pkg.ServiceTime}} {{localStrings.stepper.body.pick.service.details.DuarationUnit}} <i :class="[\'fas\',\'pointer\', showDetails == index ? \'fa-angle-down\' :\'fa-angle-left\']"></i> </span> </div> <div class="body" v-show="showDetails == index" :id="index" > <package-item-details :image="pkg.ItemImage" :desc="pkg.ItemDesc" :clientInfo="pkg.ClientInstructions" ></package-item-details> </div> </div>');
